import React from 'react';

const DescargaGoogleContacts = ({datos,index}) => {
    return (
       <a className="btn btn-primary" href={`https://apisistema.gestoraperu.pe/admin/csv/export/google/${datos.producto}/${datos.desde}/${datos.hasta}/${datos.offset}/${datos.limit}`}>Archivo {index+1} </a>
    );
};

export default DescargaGoogleContacts;